<template>
  <div class="mt-5 flex flex-col gap-3 tablet:flex-row tablet:gap-4">
    <TheButton
      :to="partnership.btnOneUrl"
      :title="partnership.btnOne"
      class="w-full tablet:w-48"
    >
      <span class="text-sm">
        {{ partnership.btnOne }}
      </span>
    </TheButton>
    <TheButton
      type="outline"
      :to="partnership.btnTwoUrl"
      :title="partnership.btnTwo"
      class="w-full tablet:w-48"
    >
      <span class="text-sm">
        {{ partnership.btnTwo }}
      </span>
    </TheButton>
  </div>
</template>

<script setup lang="ts">
  import type { IPartnership } from '@/assets/types/Home';

  interface IProps {
    partnership: IPartnership;
  }

  withDefaults(defineProps<IProps>(), {
    partnership: () => ({
      sectionTitle: '',
      btnOne: '',
      btnOneUrl: '',
      btnTwo: '',
      btnTwoUrl: '',
      pcPartnerImg: '',
    }),
  });
</script>
